import { motion } from "framer-motion";

// SVG ICONS (same as yours)
const WindIcon = () => (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path d="M2 12h20M2 6h10M2 18h15" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SnowIcon = () => (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path d="M12 2v20M4 7l16 10M4 17L20 7" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const WrenchIcon = () => (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4z" strokeWidth="2" />
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <circle cx="12" cy="12" r="3" strokeWidth="2" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3H10a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9V10a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" strokeWidth="2" />
  </svg>
);

const ShieldIcon = () => (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path d="M12 2l7 4v6c0 5-3 9-7 10-4-1-7-5-7-10V6l7-4z" strokeWidth="2" />
  </svg>
);

const PackageIcon = () => (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path d="M21 8l-9-5-9 5 9 5 9-5z" strokeWidth="2" />
    <path d="M3 8v8l9 5 9-5V8" strokeWidth="2" />
  </svg>
);

// SERVICES
const services = [
  { icon: <WindIcon />, title: "HVAC Coil Manufacturing", desc: "High-performance evaporator and condenser coils designed for durability, efficiency, and long-lasting cooling performance." },
  { icon: <SnowIcon />, title: "Cooling Solutions", desc: "Energy-efficient cooling systems for residential, commercial, and industrial applications with optimized airflow design." },
  { icon: <WrenchIcon />, title: "Installation & Setup", desc: "Professional installation services ensuring precise fitting, system balance, and maximum operational efficiency." },
  { icon: <SettingsIcon />, title: "Maintenance & Repair", desc: "Regular maintenance and fast repair services to keep your HVAC systems running smoothly and reliably." },
  { icon: <ShieldIcon />, title: "Quality Testing", desc: "Every product is rigorously tested to ensure performance, safety, and compliance with industry standards." },
  { icon: <PackageIcon />, title: "Custom Fabrication", desc: "Tailor-made coil and HVAC solutions designed according to project requirements and technical specifications." },
];

const Services = () => {
  return (
    <section className="py-14 sm:py-20 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl  sm:text-3xl md:text-4xl font-bold">
            Our Services
          </h2>
          <p className="text-gray-400 mt-3 max-w-2xl mx-auto text-sm sm:text-base">
            Delivering reliable HVAC coil solutions and cooling services designed for performance, efficiency, and durability.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {services.map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -6 }}
              className="bg-zinc-900 p-5 sm:p-6 rounded-2xl border border-zinc-800 hover:border-blue-500 transition"
            >
              <div className="text-[#1f4ba5] mb-4">
                {item.icon}
              </div>

              <h3 className="text-lg sm:text-xl font-semibold mb-2">
                {item.title}
              </h3>

              <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;